
  import { Tag } from '@/ui/components/Tag';
  import { computed, defineComponent } from 'vue';

  interface OverdueTagProps {
    date: Date|number|null;
  }

  export default defineComponent<OverdueTagProps>({
    components: { Tag },
    props: ['date'],
    setup(props) {
      const now = new Date();

      const isOverdue = computed<boolean>(() => {
        if (!props.date) {
          return false;
        }

        const date = typeof props.date === 'number' ? new Date(props.date) : props.date;

        return date < now;
      });

      return {
        isOverdue,
      };
    },
  });
